import { Component, OnInit, OnDestroy, AfterViewInit } from "@angular/core";
import { ProductService } from "src/app/shared/services/product.service";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { ShoppingCartService } from "src/app/shared/services/shopping-cart.service";
import { Product } from "src/app/shared/models/product";
import { DataService } from "src/app/shared/services/data.service";
import { THROW_IF_NOT_FOUND } from "@angular/core/src/di/injector";

@Component({
  selector: "app-product",
  templateUrl: "./product.component.html",
  styleUrls: ["./product.component.scss"],
})
export class ProductComponent implements OnInit, OnDestroy, AfterViewInit {
  cart: Product[];
  inCart: boolean = false;
  product: any = {};
  productId: number;
  subscription: Subscription;
  outOfstock: boolean = false;
  variation: any = [];
  productPrice: number;

  prodVariation: any = [];
  selectedVariation;

  productImage: string;

  merchantCurrency?: string = "";
  sliderLoaded: boolean = false;


  constructor(
    private productService: ProductService,
    private route: ActivatedRoute,
    private cartService: ShoppingCartService,
    private router: Router,
    private dataService: DataService
  ) {}

  slideConfig = {
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    autoplay: true,
  };

  slickInit(e) {
    this.sliderLoaded = true;
  }

  breakpoint(e) {
    // console.log('breakpoint');
  }
  
  find(varName: string, arr: any[]) {
    let match = arr.filter((item) => {
      if (item.name == varName) return true;
    });
    if (match && match[0]) return match[0];
  }

  fetchProduct(id: number) {
    this.productService.getProduct(id).subscribe(
      (data) => {
        console.log(data);
        this.productPrice = data.data.vatPrice;

        // console.log(data.data.quantity, data.data.no_qty_limit);
        if (data.data.quantity === 0 && !data.data.no_qty_limit) {
          this.outOfstock = true;
        }
        this.product = data.data;
        this.productImage = this.product.image;
        this.productPrice = this.product.vat_amount + this.product.price;

        // console.log(this.productPrice);

        this.prodVariation = this.product.variations;
        let productVariation = data.data.variations;

        this.getCartFromStorage();
        if (this.product.has_vat === true) {
          this.product.vatPrice =
            +this.product.price + +this.product.vat_amount;
        } else {
          this.product.vatPrice = this.product.price;
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }

  setVariation(e) {
    let varId = e.target.value;
    let varObj = this.prodVariation.filter((v) => v.id === +varId);
    this.selectedVariation = varObj[0];
    console.log(this.selectedVariation);

    if (this.selectedVariation.image) {
      this.productImage = this.selectedVariation.image;
    } else {
      this.productImage = this.product.image;
    }

    if (this.selectedVariation) {
      this.productPrice =
        this.selectedVariation.price + this.selectedVariation.vat_amount;
    } else {
      this.productPrice = this.product.vat_amount + this.product.price;
    }
  }

  getProduct() {
    this.subscription = this.route.queryParamMap.subscribe((param) => {
      this.productId = +param.get("qid");
      this.fetchProduct(this.productId);
    });
  }

  buyNow() {
    console.log(this.selectedVariation);

    if (this.selectedVariation) {
      console.log("variation");
      this.cartService.add(this.product.id, this.selectedVariation);
    } else {
      this.cartService.add(this.product.id);
    }
    this.router.navigate(["/checkout"]);
  }
  getProductfromCart() {
    this.cart.filter((cartItem) => {
      if (cartItem.id === this.product.id) {
        this.product.quantity = cartItem.quantity;
        // console.log(this.product);
        this.inCart = true;
      }
    });
  }

  getCartFromStorage() {
    this.cart = this.cartService.cartItems;
    // console.log(this.cart);
    this.getProductfromCart();
  }

  checkIfInCart() {
    let exist = this.cartService.find(this.product.id);
    // console.log(exist);
  }

  getCart() {
    this.dataService.cartItemsSubject.subscribe((cart) => {
      // console.log(cart);
      this.cart.filter((cartItem) => {
        if (cartItem.id === this.product.id) {
          this.product.quantity = cartItem.quantity;
          this.inCart = true;
        }
      });
    });
  }
  ngOnInit() {
    this.getMerchant();
    this.getProduct();
    this.getMerchant();
  }
  ngAfterViewInit() {
    this.dataService.cartItemsSubject.subscribe((cart) => {
      this.cart = cart;
      this.getProductfromCart();
    });
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  getMerchant() {
    this.dataService.merchantDetails.subscribe(data =>{
      let merchant :{merchantCurrency ?: string} = data;
      if (merchant) {
        this.merchantCurrency = merchant.merchantCurrency
      }
       // console.log(this.storeName);
       console.log("merchant currency.:",merchant.merchantCurrency);
     });
   }
  
   updateSelectedImage(image: string) {
    this.productImage = image;
  }
  moneyFormat(amount:number){
    return new Intl.NumberFormat().format(amount)
  }
}
